// eslint-disable-next-line
import FormValidation from "../../validations/es6/core/Core";
import Trigger from "../../validations/es6/plugins/Trigger";
import Bootstrap from "../../validations/es6/plugins/Bootstrap";
import Excluded from "../../validations/es6/plugins/Excluded";
import SubmitButton from "../../validations/es6/plugins/SubmitButton";
import Declarative from "../../validations/es6/plugins/Declarative";
// eslint-disable-next-line
import vat from "../../validations/es6/validators/vat";
// eslint-disable-next-line
import iban from "../../validations/es6/validators/iban";


import { getValidationMessage } from "../../utils/i18nHelper";

import profileValidationEN from "../../locales/en/profileValidation";
import profileValidationDE from "../../locales/de/profileValidation";
import profileValidationES from "../../locales/es/profileValidation";
import profileValidationFR from "../../locales/fr/profileValidation";
import profileValidationIT from "../../locales/it/profileValidation";
import profileValidationHR from "../../locales/hr/profileValidation";
import profileValidationNL from "../../locales/nl/profileValidation";
import profileValidationPT from "../../locales/pt/profileValidation";

const euCountryCodes = ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK", "GB", "GR"];

export const validationMessages = {
  en: profileValidationEN,
  de: profileValidationDE,
  es: profileValidationES,
  fr: profileValidationFR,
  it: profileValidationIT,
  hr: profileValidationHR,
  nl: profileValidationNL,
  pt: profileValidationPT,
};

const createValidationOptions = (lang) => {
  return {
    fields: {
      email: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'email', 'required', lang)
          }
        }
      },
      profile_image: {
        validators: {
          promise: {
            promise: function(input) {
              return new Promise(function(resolve, reject) {
                const files = input.element.files;
                if (
                  !files.length ||
                  typeof FileReader === "undefined" ||
                  files[0].type !== "image/jpeg"
                ) {
                  resolve({
                    valid: true
                  });
                }
  
                const img = new Image();
                img.addEventListener("load", function() {
                  const w = this.width;
                  const h = this.height;
  
                  resolve({
                    valid: w === 300 && h === 300,
                    message: getValidationMessage(validationMessages, 'profile_image', 'dimensions', lang),
                    meta: {
                      source: img.src,
                      width: w,
                      height: h
                    }
                  });
                });
                img.addEventListener("error", function() {
                  reject({
                    valid: false,
                    message: getValidationMessage(validationMessages, 'profile_image', 'choose', lang)
                  });
                });
  
                const reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.addEventListener("loadend", function(e) {
                  img.src = e.target.result;
                });
              });
            }
          },
          file: {
            extension: "jpeg,jpg",
            type: "image/jpeg",
            maxSize: 307200,
            message: getValidationMessage(validationMessages, 'profile_image', 'file', lang)
          }
        }
      },
      street_and_number: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'street_and_number', 'required', lang)
          }
        }
      },
      postal_code: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'postal_code', 'required', lang)
          }
        }
      },
      city: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'city', 'required', lang)
          }
        }
      },
      country: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'country', 'required', lang)
          }
        }
      },
      vatNumber: {
        validators: {
          vat: {
            isAnEUCountry: function() {
              let countryCode = document
              .getElementById("editProfileForm")
              .querySelector('[name="country"]').value.toUpperCase();
              return euCountryCodes.includes(countryCode)
            },
            country: function() {
              return document
                .getElementById("editProfileForm")
                .querySelector('[name="country"]').value;
            },
            message: getValidationMessage(validationMessages, 'vatNumber', 'invalid', lang)
          }
        }
      },
      iban: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'iban', 'required', lang)
          },
          iban: {
            message: getValidationMessage(validationMessages, 'iban', 'invalid', lang),
            options: {
              country: function() {
                return document
                  .getElementById("editProfileForm")
                  .querySelector('[name="country"]').value;
              }
            }
          }
        }
      },
      cardholder_name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'cardholder_name', 'required', lang)
          }
        }
      },
      card_number : {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'card_number', 'required', lang)
          },
          creditCard: {
            message: getValidationMessage(validationMessages, 'card_number', 'invalid', lang),
            options: {
              country: function() {
                return document
                  .getElementById("profilePaymentMethodForm")
                  .querySelector('[name="card_number"]').value;
              }
            }
          }
        }
      },
      expiry_year: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'card_year', 'required', lang)
          },
          regexp: {
            regexp: /([2]{1}[0-9]{3})$/,
            message: getValidationMessage(validationMessages, 'card_year', 'invalid', lang)
          }
        }
      },
      expiry_month: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'card_month', 'required', lang)
          }
        }
      },
      cvc_code: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'cvc_code', 'required', lang)
          },
          regexp: {
            regexp: /^[0-9]{3,4}$/,
            message: getValidationMessage(validationMessages, 'cvc_code', 'invalid', lang)
          }
        }
      },
      paypal_email: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'paypal_email', 'required', lang)
          },
          regexp: {
            regexp: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: getValidationMessage(validationMessages, 'paypal_email', 'invalid', lang)
          },
          emailAddress: {
            message: getValidationMessage(validationMessages, 'paypal_email', 'invalid', lang)
          },
        }
      },
      account_holder_name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'account_holder_name', 'required', lang)
          }
        }
      },
      bank_name: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'bank_name', 'required', lang)
          }
        }
      },
      bank_address: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'bank_address', 'required', lang)
          }
        }
      },
      preferred_payment_method: {
        validators: {
          notEmpty: {
            message: getValidationMessage(validationMessages, 'preferred_payment_method', 'required', lang)
          }
        }
      }
    },
    plugins: {
      trigger: new Trigger(),
      bootstrap: new Bootstrap(),
      excluded: new Excluded(),
      submitButton: new SubmitButton(),
      declarative: new Declarative({
        html5Input: true
      })
    }
  };
};

export { createValidationOptions };